<table class="table">
    <thead>
        <tr class="tr-placeholder-pcf">
            <th class="th-placeholder-pcf align-left">
                Ticker
            </th> 
            <th class="align-left">
                Description
            </th>
            <th class="align-right">
                Shares
            </th>
        <tr>
    </thead>
    <tbody>
        <tr *ngFor="let holding of pcfHoldings?.fund?.entity">
            <th class="align-left">{{holding?.ticker ? holding?.ticker : '—'}}
            </th>
            <td class="align-left">
                {{holding.shrtName ? holding.shrtName : '—'}}
            </td>
            <td class="align-right">
                {{holding.shareQuantity ? (holding.shareQuantity | number) : '—'}}
            </td>
        <tr>
    </tbody>
</table>